var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Vue, Component, Prop } from "vue-property-decorator";
import { Resources } from "../Helpers/Api.ts";
var count = 0;
var scope = "";
var globalViewer;
var globalIFrame;
var YouTube = /** @class */ (function (_super) {
    __extends(YouTube, _super);
    function YouTube() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.mediumResThumbnailExists = false;
        _this.highResThumbnailExists = false;
        return _this;
    }
    Object.defineProperty(YouTube.prototype, "embed", {
        get: function () {
            return "https://www.youtube.com/embed/" + this.id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(YouTube.prototype, "defaultThumbnail", {
        get: function () {
            return "https://img.youtube.com/vi/" + this.id + "/0.jpg";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(YouTube.prototype, "mediumResThumbnail", {
        get: function () {
            return "https://img.youtube.com/vi/" + this.id + "/mqdefault.jpg";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(YouTube.prototype, "highResThumbnail", {
        get: function () {
            return "https://img.youtube.com/vi/" + this.id + "/maxresdefault.jpg";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(YouTube.prototype, "src", {
        get: function () {
            if (this.mediumResThumbnailExists)
                return this.mediumResThumbnail;
            return this.defaultThumbnail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(YouTube.prototype, "srcset", {
        get: function () {
            if (this.mediumResThumbnailExists && this.highResThumbnailExists)
                return this.mediumResThumbnail + " 320w, " + this.highResThumbnail + " 1280w";
            return "";
        },
        enumerable: true,
        configurable: true
    });
    YouTube.prototype.play = function () {
        globalViewer.classList.add("show");
        globalViewer.onclick = this.stop.bind(this);
        globalIFrame.onload = this.iframeLoaded.bind(this);
        globalIFrame.src = this.embed;
    };
    YouTube.prototype.stop = function () {
        globalViewer.classList.remove("show");
        globalViewer.onclick = function () { };
        globalIFrame.style.width = "";
        globalIFrame.style.height = "";
        globalIFrame.src = "";
        globalIFrame.onload = function () { };
    };
    YouTube.prototype.iframeLoaded = function (e) {
        var maxPercentage = 0.75;
        var aspect = e.target.offsetWidth / e.target.offsetHeight;
        var maxWidth = document.body.offsetWidth * maxPercentage;
        var maxHeight = document.body.offsetHeight * maxPercentage;
        var width = maxWidth;
        var height = width / aspect;
        if (height > maxHeight) {
            height = maxHeight;
            width = aspect / height;
        }
        e.target.style.width = width + "px";
        e.target.style.height = height + "px";
    };
    YouTube.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            Resources.externalResourceExists(this.mediumResThumbnail).then(function (p) { return _this.mediumResThumbnailExists = p; }),
                            Resources.externalResourceExists(this.highResThumbnail).then(function (p) { return _this.highResThumbnailExists = p; })
                        ])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    YouTube.prototype.mounted = function () {
        var viewer = this.$el.querySelector(".viewer");
        for (var i = 0; i < viewer.attributes.length && !scope; i++) {
            if (viewer.attributes[i].name.indexOf("data-v-") === 0) {
                scope = viewer.attributes[i].name;
            }
        }
        if (count === 0) {
            globalViewer = window.document.body.appendChild(viewer);
            globalIFrame = globalViewer.querySelector("iframe");
        }
        else {
            viewer.remove();
        }
        count++;
    };
    YouTube.prototype.unmounted = function () {
        count--;
        if (count === 0) {
            globalViewer.remove();
        }
    };
    __decorate([
        Prop({ type: String, required: true })
    ], YouTube.prototype, "id", void 0);
    YouTube = __decorate([
        Component({
            name: "YouTube"
        })
    ], YouTube);
    return YouTube;
}(Vue));
export default YouTube;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Components/YouTube.vue
// module id = 175
// module chunks = 7 8 9